module.exports = __webpack_public_path__ + "img/nigelle_de_damas.ece1d04e.jpg";